module.exports = __webpack_public_path__ + "img/teaching.be834143.png";